// Sohel 03/30/2023 2699762545 batch Name API Changes
// Ravi 04/03/2023 2699762545 download API integrated
// Sohel 04/06/2023 2699762545 Implement View Functionality
// Sohel 04/10/2023 2699762545 Fixed Download File Issue
// Ravi 04/10/2023 2699762545 Added Print icon and integrated Api
// Akhila 04/13/2023 2699762545 Added warning popup message

import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';
import {deleteWorkQueueByAccountNumber} from './WorkQueue';
import download from '../../util/DownloadLink';

const initialData = {
  lettersData: [],
  lettersDataStatus: null,
  generateLetterStatus: null,
  isGenerateLetterLoading: false,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  letterCodes: [],
  groupCodes: [],
  letterBatchExecuteData: {},
  executeBatchStatus: null,
  requestedLetters: [],
  letterHistoryData: [],
  letterHistoryLoading: false,
  templateLink: '',
  downloadFileUrl: '',
  urlSuccessMsg: null,
  printBatchStatus: null,
  warningError: null,
};

const slice = createSlice({
  name: 'nbMaintenance',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.isGenerateLetterLoading = true;
      state.errorMsg = null;
    },
    fetchHistoryStart: (state) => {
      state.errorMsg = null;
      state.letterHistoryLoading = true;
    },
    getlettersData: (state, action) => {
      state.lettersData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.isGenerateLetterLoading = false;
      state.letterHistoryLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ?
        action.payload.data.error :
        action.payload?.data?.message ?
          action.payload?.data?.message :
          action.payload;
      state.isLoading = false;
      state.isGenerateLetterLoading = false;
      state.letterHistoryLoading = false;
    },
    fetchWarningError: (state, action) => {
      state.warningError = action?.payload?.data?.error ?
        action.payload.data.error :
        action.payload?.data?.message ?
          action.payload?.data?.message :
          action.payload;
      state.isLoading = false;
      state.isGenerateLetterLoading = false;
      state.letterHistoryLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload;
      state.isLoading = false;
      state.isGenerateLetterLoading = false;
      state.letterHistoryLoading = false;
    },
    approveBatch: (state, action) => {
      state.lettersDataStatus = action?.payload?.status;
      state.successMsg = action.payload?.response;
      state.isLoading = false;
      state.isGenerateLetterLoading = false;
      state.letterHistoryLoading = false;
    },
    generateLetter: (state, action) => {
      state.generateLetterStatus = action?.payload?.status;
      state.successMsg = action.payload?.response;
      state.isLoading = false;
      state.isGenerateLetterLoading = false;
      state.letterHistoryLoading = false;
    },
    letterExecuteBatch: (state, action) => {
      state.letterBatchExecuteData = action.payload?.response;
      state.successMsg = action.payload?.message;
      state.isLoading = false;
      state.isGenerateLetterLoading = false;
      state.executeBatchStatus = action.payload.status;
      state.letterHistoryLoading = false;
    },
    generateLetterCodes: (state, action) => {
      state.letterCodes = action.payload?.response;
      state.generateLetterCodesStatus = action?.payload?.status;
      state.successMsg = action.payload?.message;
      state.isLoading = false;
      state.letterHistoryLoading = false;
      state.isGenerateLetterLoading = false;
    },
    printBatchData: (state, action) => {
      state.printBatchStatus = action?.payload?.status;
      state.successMsg = action.payload?.response;
    },
    fetchedGroupCodes: (state, action) => {
      state.groupCodes = action.payload?.response;
      state.generateGroupCodesStatus = action?.payload?.status;
      state.successMsg = action.payload?.message;
      state.isLoading = false;
      state.isGenerateLetterLoading = false;
      state.letterHistoryLoading = false;
    },
    fetchedRequestedLetters: (state, action) => {
      state.requestedLetters = action.payload?.response;
      state.successMsg = action.payload?.message;
      state.isLoading = false;
      state.isGenerateLetterLoading = false;
      state.letterHistoryLoading = false;
    },
    fetchedLetterHistory: (state, action) => {
      state.letterHistoryData = action.payload?.response;
      state.successMsg = action.payload?.message;
      state.isLoading = false;
      state.isGenerateLetterLoading = false;
      state.letterHistoryLoading = false;
    },
    getTemplateLink: (state, action) => {
      state.templateLink = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    resetTemplateLink: (state, action) => {
      state.templateLink = '';
    },
    resetErrorMsg: (state, action) => {
      state.warningError = null;
    },
    resetLettersData: (state) => {
      state.lettersData = [];
      state.groupCodes = [];
      state.lettersDataStatus = null;
      state.generateLetterStatus = null;
      state.isLoading = false;
      state.isGenerateLetterLoading = false;
      state.letterBatchExecuteData = {};
      state.deleteLetterStatus = null;
      state.letterHistoryLoading = false;
      state.downloadFileUrl = '';
      state.printBatchStatus = null;
    },
    fetchSuccessGenerateUrl: (state, action) => {
      state.downloadFileUrl = action.payload.data;
      state.isLoading = false;
      state.errorMsg = null;
      state.urlSuccessMsg = action.payload.response;
    },
    fetchSuccessLetterGenerateUrl: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.urlSuccessMsg = action.payload.response;
    },
    resetSuccess: (state) => {
      state.deleteLetterStatus = null;
      state.lettersDataStatus = null;
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.isGenerateLetterLoading = false;
      state.executeBatchStatus = null;
      state.letterHistoryLoading = false;
      state.urlSuccessMsg = null;
    },
    resetApproveBatchResponse: (state) => {
      state.successMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

const {
  getlettersData,
  resetLettersData,
  resetApproveBatchResponse,
  approveBatch,
  fetchStart,
  fetchError,
  resetSuccess,
  generateLetter,
  fetchHistoryStart,
  fetchSuccessGenerateUrl,
  generateLetterCodes,
  fetchedLetterHistory,
  getTemplateLink,
  letterExecuteBatch,
  fetchedRequestedLetters,
  fetchedGroupCodes,
  fetchSuccessLetterGenerateUrl,
  resetTemplateLink,
  printBatchData,
  resetErrorMsg,
  fetchWarningError,
} = slice.actions;

export const fetchLettersData = (batchName) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`newlettermaintenance/get/viewletters/${batchName}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getlettersData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postApproveBatch = (groupCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/save/letterbatch`, groupCode)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(approveBatch(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const generateLetters = ({isDirty, ...details}) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/generate/letter`, details)
      .then((data) => {
        if (data && data.status && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(
            deleteWorkQueueByAccountNumber({accountNumber: details?.accountNumber, isDirty}),
          );
          dispatch(generateLetter(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchRequestedLetters = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/find/all/requestedletter`, details)
      .then((data) => {
        if (data && data.status && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchedRequestedLetters(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchLetterHistory = (details) => {
  return (dispatch) => {
    dispatch(fetchHistoryStart());
    httpPost(`lettermaintenance/find/all/letterhistory`, details)
      .then((data) => {
        if (data && data.status && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchedLetterHistory(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchLetterCodes = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/find/all/lettercode`, details)
      .then((data) => {
        if (data && data.status && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(generateLetterCodes(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const printBatch = (letterBatchId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`letter/request/save/status/${letterBatchId}`)
      .then((data) => {
        if (data && data.status && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          console.log(data);
          dispatch(printBatchData(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchGroupCodes = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/find/all/lettergroupcode`)
      .then((data) => {
        if (data && data.status && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchedGroupCodes(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const letterRequestExecuteBatch = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`letter/request/execute/letterbatch`, details)
      .then((data) => {
        if (data && data.status && data?.data?.status === 400) {
          dispatch(fetchWarningError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(letterExecuteBatch(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getTemplateDocumentLink = (key) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`letter/request/generateUrl`, key)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getTemplateLink(data?.data));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const downloadFileByUrl = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`letter/request/generate/zipfileurl`, details)
      .then((data) => {
        if (data?.status === 500 || data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          download(data?.data);
          dispatch(fetchSuccessGenerateUrl(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const downloadLetterFileByUrl = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`letter/request/generateUrl`, details)
      .then((data) => {
        if (data?.status === 500 || data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          download(data?.data);
          dispatch(fetchSuccessLetterGenerateUrl(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetSuccess());
  };
};
export const resetLetters = () => {
  return (dispatch) => {
    dispatch(resetLettersData());
  };
};
export const resetApproveBatch = () => {
  return (dispatch) => {
    dispatch(resetApproveBatchResponse());
  };
};
export const resetTemplateLinkData = () => {
  return (dispatch) => {
    dispatch(resetTemplateLink());
  };
};
export const resetErrorWarningMsg = () => {
  return (dispatch) => {
    dispatch(resetErrorMsg());
  };
};
